// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11c82smr{font:var(--ds-font-body,normal 400 14px/20px ui-sans-serif,-apple-system,BlinkMacSystemFont,\"Segoe UI\",Ubuntu,\"Helvetica Neue\",sans-serif)}\n._19bvpxbi{padding-left:var(--ds-space-200,1pc)}\n._ca0qu2gc{padding-top:var(--ds-space-100,8px)}\n._n3tdu2gc{padding-bottom:var(--ds-space-100,8px)}\n._u5f3pxbi{padding-right:var(--ds-space-200,1pc)}", ""]);
// Exports
module.exports = exports;
